import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP011_Request,
  IAPI_APP011_Response,
} from "../../../type/apiType";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

import {
  IAPI_APP009_Request,
  IAPI_APP009_Response,
} from "../../../type/apiType";

/**
 * 退職手当金支給決定額の証明依頼　回答更新API
 * @return httpAPI_APP011
 */
const httpAPI_APP011 = async (
  param: IAPI_APP011_Request
): Promise<IAPI_APP011_Response> => {
  const res = await http.post(ApiUrl.API_APP011, {
    ...param,
  });

  return res.data;
};

/**
 * 申請状況更新API
 * @return httpAPI_APP016
 */
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  const res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

/**
 * 退職手当金支給決定額の証明依頼 機構参照API
 * @return httpAPI_APP009
 */
const httpAPI_APP009 = async (
  param: IAPI_APP009_Request
): Promise<IAPI_APP009_Response> => {
  const res = await http.post(ApiUrl.API_APP009, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP011, httpAPI_APP016, httpAPI_APP009 };
